import { render, staticRenderFns } from "./ModelCatalog.vue?vue&type=template&id=e484ac2c&scoped=true"
import script from "./ModelCatalog.vue?vue&type=script&lang=js"
export * from "./ModelCatalog.vue?vue&type=script&lang=js"
import style0 from "./ModelCatalog.vue?vue&type=style&index=0&id=e484ac2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e484ac2c",
  null
  
)

export default component.exports